import s from './contactCard.module.scss'
export const ContactCard = ({children,icon}) => {
  return (
    <div className={s.card}>{icon}&nbsp;&nbsp;&nbsp;{children}</div>
  )
}
